import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, theme as antdTheme } from 'antd';
import enUS from 'antd/locale/en_US';
import { AuthProvider } from './hooks';
import { ThemeProvider, useTheme } from './contexts';
import { useVideoGenerationNotifications } from './hooks/useVideoGenerationNotifications';
import { AppLayout } from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { Login } from './pages/auth';
import { Stories, StoryDetail } from './pages/stories';
import { Tags } from './pages/tags';
import { Users } from './pages/users';
import { SourceStories, SourceStoryDetail } from './pages/source-stories';
import FilmWorkflowPage from './pages/source-stories/FilmWorkflowPage';
import FilmWorkflowFourPage from './pages/source-stories/FilmWorkflowFourPage';
import FilmWorkflowFourCreatePage from './pages/source-stories/FilmWorkflowFourCreatePage';
import SkillAdaptPage from './pages/source-stories/skillAdapt/SkillAdaptPage';
import PromptTemplates from './pages/prompt-templates';
import ImageStyles from './pages/image-styles';
import { AudioLibrary } from './pages/audio-library';
import { ROUTES } from './constants';
import './App.css';

function AppContent() {
  // Global background notification polling
  useVideoGenerationNotifications();

  return (
    <Routes>
      {/* Public routes */}
      <Route path={ROUTES.LOGIN} element={<Login />} />
      
      {/* Protected routes */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Routes>
                <Route path={ROUTES.STORIES} element={<Stories />} />
                <Route path={ROUTES.STORY_DETAIL} element={<StoryDetail />} />
                <Route path={ROUTES.TAGS} element={<Tags />} />
                <Route path={ROUTES.USERS} element={<Users />} />
                <Route path={ROUTES.SOURCE_STORIES} element={<SourceStories />} />
                <Route path={ROUTES.SOURCE_STORY_DETAIL} element={<SourceStoryDetail />} />
                <Route path={ROUTES.FILM_WORKFLOW} element={<FilmWorkflowPage />} />
                <Route path={ROUTES.FILM_WORKFLOW_FOUR} element={<FilmWorkflowFourPage />} />
                <Route path={ROUTES.FILM_WORKFLOW_FOUR_CREATE} element={<FilmWorkflowFourCreatePage />} />
                <Route path={ROUTES.SKILL_ADAPTATION} element={<SkillAdaptPage />} />
                <Route path={ROUTES.PROMPT_TEMPLATES} element={<PromptTemplates />} />
                <Route path={ROUTES.IMAGE_STYLES} element={<ImageStyles />} />
                <Route path={ROUTES.AUDIO_LIBRARY} element={<AudioLibrary />} />
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </AppLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function AppWithTheme() {
  const { isDark } = useTheme();

  return (
    <ConfigProvider
      locale={enUS}
      theme={{
        algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: {
          colorPrimary: '#FF4444',
          borderRadius: 6,
        },
      }}
    >
      <AuthProvider>
        <Router>
          <AppContent />
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppWithTheme />
    </ThemeProvider>
  );
}

export default App;
